
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/support",
      function () {
        return require("private-next-pages/help/support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/support"])
      });
    }
  